import { useEffect, useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { getHomepage } from "utils";
import { useChangeProject } from "./useChangeProject";

type NavigateToProject = {
  item: (projectId: string) => void;
  configurator: (projectId: string) => void;
};

export const useNavigateToProject = () => {
  const changeProject = useChangeProject();
  const [homepage, setHomepage] = useState<Scrivito.Obj>();

  useEffect(() => {
    Scrivito.load(() => {
      const response = getHomepage() as Scrivito.Obj;
      if (!response) {
        console.warn(
          "An error occured whilst fetching the Scrivito homepage Obj...",
        );
      }
      setHomepage(response);
    });
  }, []);

  const projectConfiguratorObj = homepage?.get(
    "projectConfiguratorPage",
  ) as Scrivito.Obj;
  const projectItemObj = homepage?.get("projectItemPage") as Scrivito.Obj;
  const navigateToProject: NavigateToProject = useMemo(
    () => ({
      item: (projectId: string) => {
        if (!projectItemObj) {
          console.error("ProjectItem Obj is not defined");
          return;
        }
        changeProject(projectId);
        Scrivito.navigateTo(projectItemObj, {
          params: {
            projectId,
          },
        });
      },
      configurator: (projectId: string) => {
        if (!projectConfiguratorObj) {
          console.error("ProjectItem Obj is not defined");
          return;
        }
        changeProject(projectId);
        Scrivito.navigateTo(projectConfiguratorObj, {
          params: {
            projectId,
          },
        });
      },
    }),
    [projectItemObj, changeProject, projectConfiguratorObj],
  );

  return navigateToProject;
};
